module.exports = __webpack_public_path__ + "img/HAH_LOGO_V3-02.45dd1dfd.svg";